// High score for logged-out players — kept in this browser via
// localStorage until they clear their cache/cookies or switch devices.
// Logged-in players use the account-backed score (see util/wordywhiz.js
// getStacksScore/submitStacksScore) instead; this is only the fallback
// so anyone can play and still see a "best" without an account.
//
// Keyed per mode — Classic, Blitz, and Challenge are different enough
// games that comparing their scores wouldn't mean anything.
const KEY_PREFIX = "wordyWhizStacksHighScore";

function keyFor(mode) {
  return `${KEY_PREFIX}:${mode}`;
}

export function getLocalHighScore(mode) {
  try {
    const n = parseInt(localStorage.getItem(keyFor(mode)), 10);
    return Number.isFinite(n) && n > 0 ? n : 0;
  } catch {
    return 0; // localStorage unavailable (private mode, blocked, etc.)
  }
}

export function setLocalHighScore(mode, score) {
  try {
    localStorage.setItem(keyFor(mode), String(score));
  } catch {
    // best-effort only — a failed write just means this session's
    // improvement won't be remembered next time.
  }
}
